<template>
  <div class="grafico">
    <div class="canvas-wrapper">
      <Bar :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'ResumenPorEncargadoBarChart',
  components: { Bar },
  props: {
    resumenEncargados: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    encargados() {
      return Array.isArray(this.resumenEncargados) ? this.resumenEncargados : []
    },
    chartData() {
      return {
        labels: this.encargados.map(e => e.NombreEncargado),
        datasets: [
          {
            label: 'Recuperación mensual (Lps)',
            data: this.encargados.map(e => e.TotalMes),
            backgroundColor: '#42A5F5',
            borderRadius: 6,
            barThickness: this.encargados.length > 5 ? 30 : 40
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Recuperación Mensual por Encargado'
          },
          tooltip: {
            callbacks: {
              label: context => `${context.parsed.y.toLocaleString()} Lps`
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: value => `${value.toLocaleString()} lps`
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.grafico {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 10px;
}

.canvas-wrapper {
  min-width: 600px;
  height: 400px;
}
</style>
